module.exports = __webpack_public_path__ + "static/qr.douyin-de128397086bfaed223765e663ca2dc4.jpeg";